module.exports = __webpack_public_path__ + "static/img/jmnr2.a7271e34.jpeg";